import { render, staticRenderFns } from "./picking.vue?vue&type=template&id=52021236&scoped=true"
import script from "./picking.vue?vue&type=script&lang=js"
export * from "./picking.vue?vue&type=script&lang=js"
import style0 from "./picking.vue?vue&type=style&index=0&id=52021236&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52021236",
  null
  
)

export default component.exports